export default __webpack_public_path__ + "static/media/9-small.ceb32575.png";